import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AlertField from "../Components/AlertField";
import useAxiosPrivate from "../Hooks/useAxiosPrivate";
import useAuth from "../Hooks/useAuth";

const BookAppointment = () => {
  const { auth } = useAuth();
  const [alert, setAlert] = useState(null);
  const [count, setCount] = useState(0);
  const [interval, setInterval] = useState();

  const [appointment, setAppointment] = useState({
    scheduled_by: auth?.user.id,
    patient_name: auth?.user.name,
    reason: "",
  });

  const [selectedTime, setSelectedTime] = useState(null);
  const [appointmentDate, setAppointmentDate] = useState(null);
  const [availableDate, setAvailableDate] = useState();

  const [file, setFile] = useState(null);
  const { id } = useParams();
  const axiosPrivate = useAxiosPrivate();
  const navigate = useNavigate();

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });

    setTimeout(() => {
      setAlert(null);
    }, 5000);
  };

  const onChange = (e) => {
    if (e.target.name === "report_image") {
      setFile({ image: e.target.files });
    } else {
      setAppointment({ ...appointment, [e.target.name]: e.target.value });
    }

    //gets the time based on date chosen
    if (e.target.name === "appointment_date") {
      if (e.target.value === "Available Dates") {
        setInterval();
      } else {
        fetchTime(appointment.doctor_id, e.target.value, appointment.id);
      }
    }
  };

  const handleRadioChange = (time) => {
    setSelectedTime(time);
  };

  useEffect(() => {
    async function fetchAppointment() {
      try {
        const response = await axiosPrivate.get(`appointment/${id}`);
        const data = response.data;
        const dates = await axiosPrivate.get(
          `user/doctor/${response?.data.doctor_id}/dates/?a_id=${data.id}`
        );
        setAppointment(data);
        setSelectedTime(data.appointment_time);
        setAppointmentDate(data.appointment_date);
        setAvailableDate(dates?.data.available_dates);
        fetchTime(data.doctor_id, data.appointment_date, data.id);
        const count = await axiosPrivate.get(`appointment/count/${id}/`);
        setCount(count.data);
      } catch (err) {
        showAlert("Appointment not found.", "warning");
      }
    }
    fetchAppointment();
  }, []);

  const fetchTime = async (id, date, a_id) => {
    try {
      const response = await axiosPrivate(
        `user/doctor/${id}/time/?date=${date}&a_id=${a_id}`
      );
      setInterval(response?.data.available_times);
    } catch (err) {
      showAlert("Load Failed", "warning");
    }
  };

  const onEditCLick = async (e) => {
    //checks if all the required fields are filled or not
    if (Object.keys(appointment).length < 5 || selectedTime === null) {
      showAlert("Fill Up all the fields.", "warning");
    } else if (appointment.appointment_date === "Available Dates") {
      showAlert("Choose a specific date for appointment.", "warning");
    } else if (appointment.reason === "Choose Your Reason") {
      showAlert("Choose a specific reason for visit.", "warning");
    } else {
      const formData = new FormData();
      //appending value of appointment in formData
      for (const key in appointment) {
        formData.append(key, appointment[key]);
      }

      //file is appended after checking its existence
      if (file !== null) {
        formData.append("report_image", file.image[0]);
      } else {
        formData.delete("report_image");
      }

      //appending id of time in formData
      formData.append("appointment_time", selectedTime);

      try {
        await axiosPrivate.put(`appointment/${id}/`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        //navigating after successful updating
        navigate("/list/appointment", {
          state: {
            message: "Appointment Updated.",
            type: "success",
          },
        });
      } catch (err) {
        if (!err?.response) {
          showAlert("No Server Response", "warning");
        } else if (err.response?.status === 400) {
          showAlert(
            err.response?.data["message"]
              ? err.response?.data["message"]
              : "Appointment is already scheduled at this time. Choose another time.",
            "warning"
          );
        } else if (err.response?.status === 404) {
          showAlert("You cannot book appointment.", "warning");
        } else {
          showAlert("Booking Failed", "warning");
        }
      }
    }
  };

  const onCancelClick = async (e) => {
    try {
      await axiosPrivate.delete(`appointment/${id}`);
      //navigating after successful cancellation
      navigate("/list/appointment", {
        state: {
          message: "Appointment Cancelled. Contact Us for fee settlement.",
          type: "success",
        },
      });
    } catch (err) {
      if (!err?.response) {
        showAlert("No Server Response", "warning");
      } else if (err.response?.status === 400) {
        showAlert(err.response.data["message"], "warning");
      } else {
        showAlert("Cancellation Failed", "warning");
      }
    }
  };

  const onConfirmClick = async () => {
    try {
      await axiosPrivate.patch(`appointment/confirm/${appointment?.id}/`);
      navigate("/list/appointment", {
        state: {
          message: "Appointment marked as confirm.",
          type: "success",
        },
      });
    } catch (err) {
      showAlert("Update Failed.", "warning");
    }
  };

  return (
    <div>
      <AlertField alert={alert} />

      <h2 className="text-center py-2">Edit Appointment</h2>

      <div className="row row-cols-2 mx-5 px-5 py-2 border bg-light">
        <div className="col px-5">
          <div className="row row-cols-2 align-items-center">
            <div>
              <img src={`data:image/jpeg;base64,${appointment?.user_image}`} width={200} height={200} alt="doctor" />
            </div>
            <div className="text-start">
              <h2>Dr. {appointment?.doctor_name?.split(" ")[0] || ""}</h2>
              <h4>{appointment?.specialization}</h4>
              <h5>No. of Patients: {count}</h5>
            </div>
          </div>
          <div className="my-4">
            <h4 className="d-inline">Patient Name</h4>
            <input
              className="mx-4 w-50"
              type="text"
              name="patient_name"
              id="patient_name"
              value={appointment?.patient_name || ""}
              disabled
            />
            <h5 className="mt-4">Reason for the visit:</h5>
            <select
              id="inputState"
              className="form-select w-50"
              name="reason"
              onChange={onChange}
              value={appointment?.reason || ""}
            >
              <option value="Choose Your Reason">Choose Your Reason</option>
              <option value="General Check-Up">General Check-Up</option>
              <option value="Others">Others</option>
            </select>
            <h5 className="mt-4">Description:</h5>
            <textarea
              name="description"
              id="description"
              cols="62"
              rows="4"
              className="p-2"
              value={appointment?.description || ""}
              onChange={onChange}
            ></textarea>
          </div>
        </div>
        <div
          className="col px-5 position-relative"
          style={{ borderLeft: "4px solid white" }}
        >
          <div className="py-4">
            <h3>Schedule</h3>
            <select
              id="inputState"
              className="form-select w-50"
              name="appointment_date"
              onChange={onChange}
              value={appointment?.appointment_date || ""}
            >
              <option defaultValue={"Choose Date"}>Available Dates</option>
              {availableDate?.map((day, i) => (
                <option onClick={onChange} key={i}>
                  {day}
                </option>
              ))}
            </select>
          </div>
          <div>
            <h3>Available Time Slots</h3>
            {interval ? (
              interval.length > 0 ? (
                <div
                  className="row row-cols-4 justify-content-space-between overflow-auto"
                  style={{ height: 7 + "rem" }}
                >
                  {interval?.map((schedule, i) => (
                    <div key={i}>
                      <input
                        type="radio"
                        className="btn-check"
                        name="appointment_time"
                        id={`appointment_time_${i}`}
                        autoComplete="off"
                        checked={
                          appointmentDate === appointment?.appointment_date &&
                          schedule === selectedTime
                        }
                        onChange={() => handleRadioChange(schedule)}
                      />
                      <label
                        className="btn btn-light border"
                        htmlFor={`appointment_time_${i}`}
                      >
                        {schedule}
                      </label>
                    </div>
                  ))}
                </div>
              ) : (
                <h6>No Time Slots Available</h6>
              )
            ) : (
              <h6 className="">Choose Appointment Date</h6>
            )}
          </div>
          <div className="py-4">
            <h5 className="d-inline">Upload</h5>
            <label className="mx-4">
              * You can upload old report to help you during consultation.
            </label>
            <input
              className="mt-2"
              type="file"
              name="report_image"
              accept="image/png, image/jpeg, application/pdf"
              id="report_image"
              onChange={onChange}
            />
            {!file && (
              <a href={appointment?.report_image} target="_blank">
                {appointment?.report_image
                  ? appointment?.report_image.split("/").pop()
                  : ""}
              </a>
            )}
          </div>
          <h5 className="d-inline mt-2">Charge</h5>
          <button className="mx-4 px-4">Rs. {appointment?.fees}</button>

          <div className="mt-4 w-100 text-center position-absolute bottom-0">
            <button className="px-5 btn btn-primary" onClick={onEditCLick}>
              Save
            </button>
            {auth?.user.roles === 0 && appointment?.is_manual && (
                        <button
                          className="px-5 ms-5 btn btn-primary"
                          onClick={onConfirmClick}
                        >
                          Confirm
                        </button>
                      )}
            <button className="btn btn-danger ms-5" onClick={onCancelClick}>
              Cancel Appointment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BookAppointment;
